import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmotionOption } from '../../models/emotionOptionEnum';

@Component({
  selector: 'app-classification-choices',
  imports: [CommonModule],
  templateUrl: './classification-choices.component.html',
  styleUrl: './classification-choices.component.scss',
})
export class ClassificationChoicesComponent {
  @Input() choices: EmotionOption[] = [];
  @Output() choiceSelected = new EventEmitter<EmotionOption>();

  onChoiceClicked(choice: EmotionOption) {
    this.choiceSelected.emit(choice);
  }
}
